import React, { useRef } from "react"
import Footer from "../../Shared/Layout/Footer"
import "../../../Styles/main.scss"
import AuthPageDescription from "../../Shared/Primitive/AuthPageDescription"
import AuthPageImage from "../../Shared/Primitive/AuthPageImage"
import SignInForm from "./SigninForm"
import { LogoIconMobile } from "../../Shared/Components/SvgIcons"
import ModalGroup from "../../Shared/Components/ModalGroup"
import Image from "../../Shared/Primitive/Image"


const SigninScreen = () => {

    return (
        <>
            <div className="auth-layout">
                <div className="auth-layout__main-container ">
                    <div className="left-panel">
                        <div className="left-panel__logo">
                            {" "}
                            <LogoIconMobile />
                        </div>
                        <div className="left-panel__description">
                            <AuthPageDescription />
                        </div>
                        <div className="edusiia-image">
                            <AuthPageImage />
                        </div>
                    </div>

                    <div className="right-panel right-panel--height-61">
                        <div className="right-panel__edusiia-image">
                            <AuthPageImage />
                        </div>
                        <div className="right-panel__signin-form">
                            <SignInForm />
                        </div>
                    </div>
                </div>
                <div className="auth-layout__row">
                    <div className="auth-layout__row--text-panel">
                        <h2>Werdet Teil der Bildungs-Community!</h2>
                        <p>
                            Unser soziales Netzwerk ist gezielt auf Bildungsakteur:innen ausgerichtet. Ihr
                            legt einfach ein Profil an und könnt sofort mit anderen in den Austausch treten,
                            Themen-bezogene Räume erkunden, neue Kontakte finden und
                            Herausforderungen und Lösungen diskutieren.
                        </p>

                        <p>
                            Bei edusiia tummeln sich Akteur:innen aller Bildungsbereiche, die für einen
                            positiven Wandel in der Bildung eintreten. Eure Organisation ist noch nicht Teil
                            des Netzwerks? Dann legt doch einfach direkt bei der Registrierung oder später
                            ein separates Profil für sie an. edusiia ist für alle Bildungsakteur:innen kostenlos!
                        </p>
                    </div>
                    <div className="auth-layout__row--image-panel">
                        <Image src="/edusiia_2024_Illustration_Soziales_Netzwerk.jpg" className="auth-layout__row--image" />
                    </div>
                </div>
                <div className="auth-layout__row auth-layout__row--grey">
                    <div className="auth-layout__row--image-panel">
                        <Image src="/edusiia-idee.png" className="auth-layout__row--image" />

                    </div>
                    <div className="auth-layout__row--text-panel">
                        <h2>Die richtigen Funktionen für Bildungsakteur:innen</h2>
                        <p>
                            <ul>
                                <li>
                                    <strong>Profile für Organisationen und Personen:</strong> Erstellt und gestaltet Profile für eure Organisation und die Mitglieder eurer Community.
                                </li>
                                <li>
                                    <strong>Virtuelle Diskussionsräume:</strong> Bindet eure Mitglieder und Verbündete aktiv ein und ermöglicht ihnen produktive Zusammenarbeit – jederzeit und überall. Ihr könnt sowohl private als auch öffentliche Räume anlegen.
                                </li>
                                <li>
                                    <strong>Vielfältige Beiträge:</strong> Teilt Texte, Bilder und Dateien mit eurer Community und versorgt sie mit allen wichtigen Infos.
                                </li>
                                <li>
                                    <strong>Matching:</strong> Profitiert von unserem gezielten Matching, das euch mit anderen interessanten Mitgliedern zusammenbringt.
                                </li>
                                <li>
                                    <strong>Persönlicher Chat:</strong> Geht in den 1:1 Austausch mit anderen Mitgliedern und teilt eure Vorschläge, Ideen und Fragen mit ihnen.
                                </li>
                                <li>
                                    <strong>Gezielte Suche:</strong> Findet direkt interessante Bildungsakteur:innen und -inhalte in der größeren Bildungscommunity.
                                </li>
                            </ul></p>
                    </div>
                </div>
                <div className="auth-layout__row">
                    <div className="auth-layout__row--text-panel">
                        <h2>So profitiert ihr von edusiia</h2>
                        <p>
                            <ul>
                                <li>
                                    Wir stärken die <strong>Zusammenarbeit</strong> mit euren Zielgruppen digital und in Präsenz.
                                </li>
                                <li>
                                    Ihr bekommt ein soziales Netzwerk für eure Community, das <strong>leicht zu bedienen</strong> und komplett auf Bildung zugeschnitten ist.
                                </li>
                                <li>
                                    Ihr könnt eure Veranstaltungen <strong>interaktiver</strong> gestalten, digital verlängern und damit Teilnehmende langfristig an euch binden.
                                </li>
                                <li>
                                    Ihr werdet als Organisation deutlich <strong>sichtbarer</strong> in der Bildungslandschaft.
                                </li>
                                <li>
                                    Ihr findet <strong>neue Mitglieder</strong>, Kund:innen und Mitarbeitende in der größeren edusiia Bildungscommunity.
                                </li>
                                <li>
                                    Durch eure <strong>gestärkte Community</strong> werdet ihr effizienter und könnt mehr Wirkung entfalten.
                                </li>
                            </ul>
                        </p>
                    </div>
                    <div className="auth-layout__row--image-panel">
                        <Image src="/edusiia-Hosting-Deutschland.png" className="auth-layout__row--image" />
                        <Image src="/edusiia-Datenschutz-DSGVO.png" className="auth-layout__row--image" />

                    </div>
                </div>
                <Footer />
                <ModalGroup />
            </div>
        </>
    )
}

export default SigninScreen
